/* ----------------------------------------
    Node Modules
---------------------------------------- */

import anime from 'animejs';

/* ----------------------------------------
    Utilites
---------------------------------------- */

import * as dom from '@util/dom';

/* ----------------------------------------
    Animations
---------------------------------------- */

const navAnimation = (el, ani) => {
    anime({
        targets: el,
        translateY: ['-100%', '0%'],
        easing: 'easeOutExpo',
        delay: ani.delay + 100,
        duration: ani.duration / 4,
        complete: () => el.style = ''
    });
};

const logoAnimation = (el, ani) => {
    anime({
        targets: el,
        scale: 1.25,
        opacity: 0,
        easing: 'easeOutExpo',
        delay: ani.delay,
        duration: ani.duration / 5,
        complete: () => el.remove()
    });
};

const awardAnimation = (el, ani) => {
    anime({
        targets: el,
        translateY: 0,
        translateX: '25%',
        rotate: 0,
        opacity: 1,
        easing: 'easeOutExpo',
        duration: ani.duration / 5,
        complete: () => el.style = ''
    });
};

const resizeAnimation = (els, values, pos) => {
    return new Promise((resolve) => {
        anime({
            targets: els.clone,
            width: values.width,
            height: values.height,
            top: pos.top,
            left: pos.left,
            easing: 'easeInOutQuint',
            delay: 2500,
            duration: 1200,
            begin: (ani) => {
                document.body.style.overflow = 'hidden';
                navAnimation(els.nav_main, ani);
                navAnimation(els.nav_sticky, ani);
                logoAnimation(els.logo, ani);
            },
            complete: (ani) => {
                document.body.style.overflow = 'auto';
                els.clone.remove();
                els.award && awardAnimation(els.award, ani);
                resolve();
            }
        });
    });
};

/* ----------------------------------------
    Vruchtvlees Logo
---------------------------------------- */

const logo = () => {
    return `
        <svg width="235px" height="25px" viewBox="0 0 235 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="vruchtvlees-logo" fill-rule="nonzero" fill="#FFFFFF">
                    <path d="M20.4784,24.2727 L15.4274,24.2727 L10.9734,9.5607 C10.8714,9.2467 10.7864,8.9597 10.7224,8.7077 L10.5984,8.2657 L10.5034,8.6727 L10.3744,9.0867 C10.3344,9.2337 10.2934,9.3907 10.2474,9.5607 L5.7674,24.2727 L0.5914,24.2727 L8.1344,1.2257 L12.9654,1.2257 L20.4784,24.2727 Z M42.0744,1.2254 L35.9504,10.8574 C37.4664,11.2714 38.6994,12.0404 39.6604,13.1424 C40.6154,14.2484 41.0964,15.6634 41.0964,17.3894 C41.0964,18.3794 40.9114,19.2954 40.5404,20.1364 C40.1764,20.9794 39.6434,21.7024 38.9484,22.3134 C38.2554,22.9254 37.4174,23.4044 36.4384,23.7534 C35.4574,24.0994 34.3724,24.2724 33.1684,24.2724 L24.9004,24.2724 L24.9004,1.2254 L29.9494,1.2254 L29.9494,12.1174 L36.3594,1.2254 L42.0744,1.2254 Z M35.2684,15.2434 C34.7554,14.7174 34.0554,14.4524 33.1684,14.4524 L29.9494,14.4524 L29.9494,20.0094 L33.1684,20.0094 C33.9714,20.0094 34.6504,19.7714 35.2064,19.3004 C35.7644,18.8264 36.0424,18.1874 36.0424,17.3894 C36.0424,16.4834 35.7854,15.7694 35.2684,15.2434 Z M66.7596,10.5715 L66.7596,24.2725 L61.7396,24.2725 L61.7396,10.5715 C61.7396,9.7905 61.6066,9.0715 61.3466,8.4055 C61.0836,7.7445 60.7206,7.1775 60.2556,6.7075 C59.7956,6.2275 59.2586,5.8605 58.6466,5.5985 C58.0376,5.3345 57.3746,5.2025 56.6596,5.2025 C55.9606,5.2025 55.3246,5.3345 54.7486,5.5985 C54.1686,5.8605 53.6646,6.2275 53.2326,6.7075 C52.7986,7.1775 52.4696,7.7445 52.2366,8.4055 C52.0066,9.0715 51.8916,9.7905 51.8916,10.5715 L51.8916,24.2725 L46.8046,24.2725 L46.8046,10.5715 C46.8046,8.9925 47.0706,7.5965 47.5976,6.3875 C48.1206,5.1755 48.8426,4.1625 49.7466,3.3415 C50.6506,2.5205 51.6946,1.8995 52.8856,1.4775 C54.0756,1.0555 55.3306,0.8465 56.6596,0.8465 C58.0026,0.8465 59.2906,1.0555 60.5106,1.4775 C61.7296,1.8995 62.8046,2.5205 63.7296,3.3415 C64.6556,4.1625 65.3936,5.1755 65.9396,6.3875 C66.4866,7.5965 66.7596,8.9925 66.7596,10.5715 Z M92.3016,4.5735 L89.3976,7.8865 C89.0196,7.5305 88.6416,7.1905 88.2606,6.8745 C87.8846,6.5615 87.4676,6.2855 87.0136,6.0555 C86.5626,5.8235 86.0556,5.6345 85.4996,5.4875 C84.9426,5.3405 84.3036,5.2665 83.5886,5.2665 C81.4416,5.2665 79.8076,5.9405 78.6946,7.2885 C77.5796,8.6335 77.0226,10.4965 77.0226,12.8765 C77.0226,13.9285 77.1766,14.9075 77.4776,15.8095 C77.7846,16.7165 78.2186,17.4945 78.7726,18.1445 C79.3326,18.8015 80.0096,19.3075 80.8126,19.6775 C81.6116,20.0465 82.5026,20.2335 83.4966,20.2335 C85.5986,20.2335 87.4206,19.4605 88.9556,17.9265 L91.7966,21.2385 C90.5976,22.4615 89.3396,23.3345 88.0256,23.8605 C86.7076,24.3895 85.2006,24.6485 83.4966,24.6485 C81.8736,24.6485 80.3516,24.3615 78.9336,23.7835 C77.5116,23.2045 76.2746,22.3905 75.2226,21.3525 C74.1696,20.3105 73.3366,19.0675 72.7296,17.6235 C72.1206,16.1845 71.8136,14.5995 71.8136,12.8765 C71.8136,11.0205 72.0976,9.3555 72.6646,7.8715 C73.2346,6.3875 74.0316,5.1225 75.0666,4.0795 C76.0956,3.0395 77.3366,2.2415 78.7916,1.6815 C80.2416,1.1235 81.8436,0.8465 83.5886,0.8465 C85.5886,0.8465 87.2726,1.1775 88.6416,1.8395 C90.0076,2.5035 91.2286,3.4135 92.3016,4.5735 Z M115.348,1.2258 L115.348,24.2728 L110.299,24.2728 L110.299,14.7068 L102.277,14.7068 L102.277,24.2728 L97.226,24.2728 L97.226,1.2258 L102.277,1.2258 L102.277,10.4438 L110.299,10.4438 L110.299,1.2258 L115.348,1.2258 Z M134.4823,20.011 L134.4823,24.273 L120.3993,24.273 L120.3993,20.011 L124.9803,20.011 L124.9803,1.226 L130.0263,1.226 L130.0263,20.011 L134.4823,20.011 Z M157.5267,24.2727 L152.4747,24.2727 L148.0247,9.5607 C147.9197,9.2467 147.8347,8.9597 147.7697,8.7077 L147.6447,8.2657 L147.5497,8.6727 L147.4257,9.0867 C147.3807,9.2337 147.3407,9.3907 147.2957,9.5607 L142.8107,24.2727 L137.6387,24.2727 L145.1827,1.2257 L150.0147,1.2257 L157.5267,24.2727 Z M175.2069,1.2258 L175.2069,5.4878 L166.9989,5.4878 L166.9989,24.2728 L161.9449,24.2728 L161.9449,1.2258 L175.2069,1.2258 Z M194.1493,1.2258 L194.1493,5.4878 L185.3083,5.4878 L185.3083,10.3518 L193.0763,10.3518 L193.0763,14.6148 L185.3083,14.6148 L185.3083,20.0088 L193.6773,20.0088 L193.6773,24.2728 L180.2613,24.2728 L180.2613,1.2258 L194.1493,1.2258 Z M213.7855,1.2258 L213.7855,5.4878 L204.9435,5.4878 L204.9435,10.3518 L212.7125,10.3518 L212.7125,14.6148 L204.9435,14.6148 L204.9435,20.0088 L213.3105,20.0088 L213.3105,24.2728 L199.8945,24.2728 L199.8945,1.2258 L213.7855,1.2258 Z M233.8031,10.2092 C233.5291,10.8912 233.1691,11.4842 232.7271,11.9732 C232.2861,12.4702 231.7901,12.8842 231.2411,13.2232 C230.6951,13.5602 230.1401,13.8552 229.5701,14.1042 C228.8961,14.4002 228.2301,14.6672 227.5661,14.9122 C226.9051,15.1512 226.3041,15.4182 225.7651,15.7002 C225.2311,15.9842 224.7921,16.3072 224.4551,16.6602 C224.1201,17.0222 223.9541,17.4612 223.9541,17.9902 C223.9541,18.2222 224.0041,18.4672 224.1111,18.7302 C224.2131,18.9932 224.3931,19.2372 224.6471,19.4602 C224.8971,19.6792 225.2261,19.8632 225.6251,20.0112 C226.0241,20.1562 226.5181,20.2302 227.1101,20.2302 C227.9501,20.2302 228.7681,20.1052 229.5541,19.8522 C230.3451,19.5972 230.9891,19.2822 231.4981,18.9002 L233.7681,22.6632 C232.8201,23.3542 231.7471,23.8602 230.5501,24.1782 C229.3491,24.4942 228.2001,24.6532 227.1101,24.6532 C226.0991,24.6532 225.0991,24.5232 224.1111,24.2722 C223.1201,24.0212 222.2421,23.6262 221.4711,23.0892 C220.7061,22.5542 220.0841,21.8622 219.6131,21.0192 C219.1361,20.1762 218.9021,19.1702 218.9021,17.9902 C218.9021,17.0632 219.0071,16.2762 219.2161,15.6232 C219.4231,14.9692 219.7181,14.3962 220.0991,13.8982 C220.4761,13.4042 220.9201,12.9802 221.4241,12.6212 C221.9331,12.2622 222.4671,11.9312 223.0361,11.6112 C223.5201,11.3372 224.1111,11.0752 224.8071,10.8232 C225.4981,10.5712 226.1691,10.2912 226.8271,9.9872 C227.4761,9.6832 228.0301,9.3212 228.4841,8.9122 C228.9331,8.5032 229.1631,8.0142 229.1631,7.4452 C229.1631,6.7522 228.9631,6.2152 228.5591,5.8362 C228.1591,5.4572 227.3821,5.2652 226.2241,5.2652 C225.2761,5.2652 224.3411,5.4622 223.4201,5.8512 C222.4871,6.2402 221.6891,6.7072 221.0151,7.2582 L218.3951,3.7212 C219.5081,2.8572 220.6761,2.1612 221.8981,1.6352 C223.1201,1.1112 224.5301,0.8472 226.1291,0.8472 C228.6341,0.8472 230.6071,1.4522 232.0471,2.6602 C233.4911,3.8702 234.2121,5.5712 234.2121,7.7592 C234.2121,8.7102 234.0731,9.5232 233.8031,10.2092 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </svg>
    `;
};

/** ----------------------------------------
    Welcome
 ---------------------------------------- */

export class Opening {

    constructor() {
        this.els = {};
        this.dimensions = {};
        this.position = {};
    }

    /** ----------------------------------------
         Styling
     ---------------------------------------- */

    _defaultStyling() {
        return {
            position: 'relative',
            overflow: 'hidden'
        };
    }

    _fullScreenStyling() {
        return {
            width: dom.unit(window.innerWidth),
            height: dom.unit(window.innerHeight),
            position: 'fixed',
            top: '0',
            left: '0',
            zIndex: 1000000
        };
    }

    _logoStyling() {
        return {
            width: '35%',
            height: '100%',
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        };
    }

    _awardStyling() {
        return {
            opacity: 0,
            transform: 'translateY(75%) translateX(100%) rotate(15deg)'
        };
    }

    _setStyling(el, type) {
        const styles = {
            default: this._defaultStyling(),
            screen: this._fullScreenStyling(),
            logo: this._logoStyling(),
            award: this._awardStyling()
        };

        for (let [key, value] of Object.entries(styles[type])) {
            el.style[key] = value;
        }
    }

    /** ----------------------------------------
         Default Position
     ---------------------------------------- */

    _defaultPosition(el) {
        this.position = el.getBoundingClientRect();

        this.dimensions = {
            width: el.offsetWidth,
            height: el.offsetHeight
        };
    }

    /** ----------------------------------------
         Full Screen
     ---------------------------------------- */

    _setFullScreen() {
        const clone = this.els.thumb.cloneNode(true);
        this._setStyling(clone, 'screen');
        document.body.appendChild(clone);
        this.els.clone = clone;
    }

    /** ----------------------------------------
        Logo
     ---------------------------------------- */

    _setLogo() {
        this.els.clone.insertAdjacentHTML('beforeend', logo());
        this.els['logo'] = this.els.clone.querySelector('svg');
        this._setStyling(this.els.logo, 'logo');
    }

    /** ----------------------------------------
         award
     ---------------------------------------- */

    _setAward() {
        if(!this.els.award) return;
        this._setStyling(this.els.award, 'award');
    }

    /** ----------------------------------------
         Block Scrolling
     ---------------------------------------- */

    _blockScroll() {
        document.body.style.overflow = 'hidden';
    }

    _releaseScroll() {
        document.body.style.overflow = 'auto';
    }

    /** ----------------------------------------
        Set Elements
     ---------------------------------------- */

    _setEls() {
        this.els['nav_main'] = document.querySelector('.nav--main');
        this.els['nav_sticky'] = document.querySelector('.nav--sticky');
        this.els['header'] = document.querySelector('.header--home');
        this.els['award'] = this.els.header.querySelector('.award');
        this.els['thumb'] = this.els.header.querySelector('.card__thumb');

        this._defaultPosition(this.els.thumb);
    }

    /** ----------------------------------------
         Initialize
     ---------------------------------------- */

    init() {
        this._setEls();

        if(!this.els.header) return;

        this._setFullScreen();
        this._setLogo();
        this._setAward();

        return resizeAnimation(this.els, this.dimensions, this.position);
    }

}
